import { IWallFacadeData } from "common/records/WallFacade";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_WALL_FACADE = "@wallFacades/RECEIVE_WALL_FACADE";

export const WallFacadeActions = {
  receiveWallFacade: (wallFacade: Partial<IWallFacadeData>) => createAction(RECEIVE_WALL_FACADE, { wallFacade }),
};

export type WallFacadeActions = ActionsUnion<typeof WallFacadeActions>;
